import { useDispatch } from "react-redux"
import {
  groupCreativesLoading,
  groupCreativesSuccess,
  groupCreativesFailure,
  ungroupCreativesLoading,
  ungroupCreativesSuccess,
  ungroupCreativesFailure,
} from "@redux/slices/creativeGroupingSlice"
import { groupCreativesFromFolderUrl } from "@services/ml/groupCreativesFromFolderUrl"
import { ungroupCreatives } from "@services/ml/ungroupCreatives"
import { useNavigate } from "react-router"

const useCreativeGrouping = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleGroupCreatives = async (data) => {
    try {
      dispatch(groupCreativesLoading())
      const response = await groupCreativesFromFolderUrl(data)
      dispatch(groupCreativesSuccess(response.data))
      navigate("/group-creatives")
    } catch (error) {
      dispatch(groupCreativesFailure())
      console.error("Error grouping creatives:", error)
      throw error
    }
  }

  const handleUngroupCreatives = async (data) => {
    try {
      dispatch(ungroupCreativesLoading())
      await ungroupCreatives(data)
      dispatch(ungroupCreativesSuccess())
    } catch (error) {
      dispatch(ungroupCreativesFailure())
      console.error("Error ungrouping creatives:", error)
      throw error
    }
  }

  return {
    handleGroupCreatives,
    handleUngroupCreatives,
  }
}

export default useCreativeGrouping
